<script lang="ts">
	export let width: number
	export let title: string
	export let suptext: string
	export let image: {
		data: {
			attributes: {
				url: string
			}
		}
	}
	export let article: {
		data: {
			attributes: {
				title: string
				mainImage: {
					data: {
						attributes: {
							url: string
						}
					}[]
				}
				content: {
					text: string
				}[]
			}
		}
	}

	const header = title || article?.data?.attributes?.title
	const img =
		image?.data?.attributes?.url || article?.data?.attributes?.mainImage?.data?.[0]?.attributes?.url

	const content = article?.data?.attributes?.content?.[0]?.text
</script>

<div class="col-span-{width} flex w-full max-w-full flex-col items-center">
	<div class="max-w-full text-center md:max-w-4xl">
		{#if suptext}
			<h6 class="mb-6 text-lg font-semibold text-primary-500">{suptext}</h6>
		{/if}

		{#if header}
			<h2 class="unstyled text-4.5xl-res font-semibold">{@html header}</h2>
		{/if}
	</div>

	<img
		src={img}
		alt={header || 'Woltair'}
		class="mb-12 mt-12 aspect-[8/3] w-full rounded-md object-cover object-center"
	/>
	<div class="article-01-text-cont relative max-w-full overflow-x-hidden md:max-w-3xl">
		{@html content}
	</div>
</div>

<style lang="scss">
	:global(.article-01-text-cont) {
		:global(h1) {
		}

		:global(h2) {
		}

		:global(h3) {
		}

		:global(h4) {
		}

		:global(h5) {
		}

		:global(h6) {
		}

		:global(p) {
			@apply mb-4 mt-2 text-lg leading-loose;
		}

		:global(strong) {
			@apply font-bold;
		}

		:global(ul) {
			@apply my-6 list-disc;
		}

		:global(li) {
			@apply my-2 text-lg;
		}

		:global(a) {
			@apply text-primary-500;
		}

		:global(figure.table) {
			@apply block w-full max-w-full overflow-x-scroll;
		}
	}
</style>
